
const apiConfig = {
    GENERATE_LOGIN_OTP: {
        url: '/auth/hub/verify',
        method: 'POST'
    },
    LOGIN: {
        url: '/auth/hub/login',
        method: 'POST'
    },
    GENERATE_REGISTRATION_OTP: {
        url: '/auth/validate',
        method: 'POST'
    },
    REGISTER: {
        url: '/auth/hub/register',
        method: 'POST'
    },
    FETCH_USER_PROFILE: {
        url: '/user/profile',
        method: 'GET'
    },
    UPDATE_USER_PROFILE: {
        url: 'h/<hubId>/profile',
        method: 'GET'
    },
    FETCH_USERS: {
        url: '/h/<hubId>/user',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_USER: {
        url: '/h/<hubId>/user/<userId>/edit',
        method: 'GET',
        staleTime: 0
    },
    CREATE_USER: {
        url: '/h/<hubId>/user',
        method: 'POST',
    },
    UPDATE_USER: {
        url: '/h/<hubId>/user/<userId>',
        method: 'PUT',
    },
    DELETE_USER: {
        url: '/h/<hubId>/user/<userId>',
        method: 'DELETE',
    },
    FETCH_USER_BRANDS: {
        url: '/h/<hubId>/brand/list',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_ROLES: {
        url: '/h/role',
        method: 'GET',
        staleTime: 10*60*1000
    },

    CREATE_CAMPAIGN: {
        url: '/h/<hubId>/campaign',
        method: 'POST'
    },

    FETCH_CAMPAIGNS: {
        url: '/h/<hubId>/campaign',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGN: {
        url: '/h/<hubId>/campaign/<campaignId>',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CAMPAIGN_DETAILS: {
        url: '/h/<hubId>/campaign/<campaignId>/edit',
        method: 'GET',
        staleTime: 0
    },
    UPDATE_CAMPAIGN_DETAILS: {
        url: '/h/<hubId>/campaign/<campaignId>',
        method: 'PUT',
    },
    FETCH_CAMPAIGN_REQUIREMENT: {
        url: '/h/<hubId>/campaign/<campaignId>/requirement',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CITIES: {
        url: 'h/city/list',
        method: 'GET'
    },
    FETCH_TOPICS: {
        url: 'h/topic/list',
        method: 'GET'
    },

    FETCH_REGIONS: {
        url: 'h/region/list',
        method: 'GET',
        staleTime: 10*60*1000
    },

    FETCH_CAMPAIGN_CREATIVES: {
        url: '/h/<hubId>/campaign/<campaignId>/creative',
        method: "GET",
        staleTime: 0
    },
    UPDATE_CAMPAIGN_CREATIVES: {
        url: '/h/<hubId>/campaign/<campaignId>/creative',
        method: "POST"
    },
    FETCH_CAMPAIGN_GALLERY: {
        url: '/h/<hubId>/campaign/<campaignId>/file',
        method: "GET",
        staleTime: 0
    },
    ADD_CAMPAIGN_GALLERY_IMAGE: {
        url: '/h/<hubId>/campaign/<campaignId>/file',
        method: "POST",
    },
    DELETE_CAMPAIGN_GALLERY_IMAGE: {
        url: '/h/<hubId>/campaign/<campaignId>/file/<fileId>',
        method: "DELETE",
    },

    FETCH_CAMPAIGN_APPLICATIONS: {
        url: '/h/<hubId>/campaign/<campaignId>/application',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION: {
        url: '/h/<hubId>/campaign/<campaignId>/application/<influencerId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION_POSTS: {
        url: '/h/<hubId>/campaign/<campaignId>/application/<influencerId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },
    PROCESS_APPLICATION: {
        url: '/h/<hubId>/campaign/<campaignId>/application/<influencerId>',
        method: 'PUT',
    },
    FETCH_INFLUENCER_INSIGHTS: {
        url: 'h/<hubId>/influencer/<influencerId>/insights',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_INFLUENCER_POST: {
        url: 'h/<hubId>/influencer/<influencerId>/post/<postId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATIONS: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATION: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_INFLUENCER_MEDIA: {
        url: 'h/<hubId>/influencer/<influencerId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGN_PAYMENTS: {
        url: 'h/<hubId>/campaign/<campaignId>/payment',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_INSIGHTS: {
        url: 'h/<hubId>/campaign/<campaignId>/insights',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_PERFORMANCE: {
        url: 'h/<hubId>/campaign/<campaignId>/performance',
        method: 'GET',
        staleTime: 5*60*1000
    },
    PROCESS_COLLABORATION: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<influencerId>',
        method: 'PUT',
    },
    REQUEST_CAMPAIGN_APPROVAL: {
        url: '/h/<hubId>/campaign/<campaignId>/approval',
        method: 'POST',
    },
    MARK_CAMPAIGN_COMPLETED: {
        url: '/h/<hubId>/campaign/<campaignId>/complete',
        method: 'POST',
    },
    FETCH_CAMPAIGNS_COUNT: {
        url: '/h/<hubId>/campaign/totals',
        method: 'GET',
        staleTime: 1*60*1000
    },
    BOOKMARK_APPLICATION: {
        url: '/h/<hubId>/campaign/<campaignId>/application/<influencerId>/bookmark',
        method: 'POST',
    },
    FETCH_COLLABORATION_TASKS: {
        url: '/h/<hubId>/collaboration/task',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_COLLABORATION_MILESTONE: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/milestone/<milestoneId>',
        method: "GET",
        staleTime: 1*60*1000
    },
     FETCH_COLLABORATION_PERMALINK_FILE: {
        method: "POST",
        url: "/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/permalink-file",
        staleTime: 10*60*1000
    },
    PROCESS_COLLABORATION_MILESTONE_STEP: {
        method: 'POST',
        url: "/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/step"
    },
    SUBMIT_STEP_DEADLINE: {
        method: "POST",
        url: "/h/<hubId>/campaign/<campaignId>/collaboration/<influencerId>/step/<stepSlug>/deadline"
    },
    FETCH_MAP_PLACES: {
        method: 'POST',
        url: '/h/place/search'
    },
    FETCH_PLACE: {
        method: 'GET',
        url: '/h/place/<placeId>'
    },
     FETCH_ADDRESS: {
        url: '/h/address/<addressUUID>',
        method: "GET",
        staleTime: 10*60*1000
    },
    STORE_ADDRESS: {
        method: 'POST',
        url: '/h/<hubId>/influencer/<influencerId>/address'
    },
    STORE_HUB_ADDRESS: {
        method: 'POST',
        url: '/h/<hubId>/address'
    },
    FETCH_ADDRESSES: {
        method: 'GET',
        url: '/h/<hubId>/address',
        staleTime: 10*60*1000   
    },
    FETCH_PLACE_LOCAL: {
        method: 'GET',
        url: '/h/address/create'
    },
     GET_SIGNED_GCS_URL: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/upload/url',
        method: "POST"
    },
    LINK_UPLOADED_GCS_FILE_WITH_MILESTONE_STEP: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/upload/link',
        method: 'POST'
    },
    FETCH_COLLABORATIONS:  {
        url: '/h/<hubId>/collaboration',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_COLLABORATION: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_BASIC_POST: {
        method: 'url',
        url: '/h/post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_CAMPAIGNS_ACTIVITY: {
        url: '/h/<hubId>/campaign/activity',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_COLLABS_SUMMARY: {
        url: 'h/<hubId>/collaboration/task/summary',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_BASIC_SOCIAL_POST: {
        method: 'url',
        url: '/h/social-post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_POST: {
        url: '/h/<hubId>/social-account/<socialAccountId>/post/<socialPostId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_POSTS: {
        url: '/h/<hubId>/social-account/<socialAccountId>/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    // Creators
    FETCH_CONTACTS: {
        url: '/h/<hubId>/contact',
        method: 'GET',
        staleTime: 1*60*1000
    },
    CREATE_CONTACT: {
        url: '/h/<hubId>/contact',
        method: 'POST',
    },
    BULK_CREATE_CONTACT: {
        url: '/h/<hubId>/contact/bulk',
        method: 'POST',
    },
    UPDATE_CONTACT_TAGS: {
        url: '/h/<hubId>/contact/<socialAccountId>',
        method: 'PUT',
    },
    UPDATE_CONTACT_MOBILE: {
        url: '/h/<hubId>/contact/<socialAccountId>/mobile',
        method: 'POST',
    },
    FETCH_INFLUENCER: {
        url: '/h/<hubId>/influencer/<influencerId>/edit',
        method: 'GET',
        staleTime: 0
    },
    UPDATE_INFLUENCER: {
        url: '/h/<hubId>/influencer/<influencerId>',
        method: 'PUT',
        staleTime: 0
    },
    APPLY_CAMPAIGN: {
        url: '/h/<hubId>/application',
        method: 'POST',
    },
    FETCH_APPLICATIONS: {
        url: '/h/<hubId>/application',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_LATEST_SOCIAL_MEDIA: {
        url: '/h/<hubId>/social-account/<socialAccountId>/fetch-media',
        method: 'POST',
        staleTime: 1*60*1000
    },
    FETCH_INFLUENCER_ADDRESSES: {
        method: 'GET',
        url: '/h/<hubId>/influencer/<influencerId>/address',
        staleTime: 10*60*1000   
    },
    FETCH_URL_METADATA: {
        method: 'POST',
        url: '/h/url/md',
    },
    CREATE_FIREBASE_TOKEN: {
        url: '/h/<hubId>/firebase-token',
        method: 'POST',
        staleTime: 50*60*1000
    },
    COLLAB_CHAT_ROOM: {
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/chat-room',
        method: 'POST'
    },
    FETCH_CREATOR_TAGS: {
        url: '/h/<hubId>/creator-tag',
        method: 'GET',
    },
    SEARCH_CREATOR_TAGS: {
        url: '/h/<hubId>/creator-tag/list',
        method: 'GET',
    },
    CREATE_CREATOR_TAG: {
        url: '/h/<hubId>/creator-tag',
        method: 'POST',
    },
    UPDATE_CREATOR_TAG: {
        url: '/h/<hubId>/creator-tag/<creatorTagId>',
        method: 'PUT',
    },
    DELETE_CREATOR_TAG: {
        url: '/h/<hubId>/creator-tag/<creatorTagId>',
        method: 'DELETE',
    },
    FETCH_PAN_DETAILS : {
        method: 'GET',
        url: '/h/<hubId>/pan',
        staleTime: 10*60*1000
    },
    VALIDATE_PAN: {
        method: 'POST',
        url: '/h/<hubId>/pan/validate'
    },
    STORE_PAN: {
        method: 'POST',
        url: '/h/<hubId>/pan'
    },
    STORE_COLLAB_REMOVAL_REQUEST: {
        method: 'POST',
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/deletion-request',
    },
    DESTROY_COLLAB_REMOVAL_REQUEST: {
        method: 'DELETE',
        url: '/h/<hubId>/campaign/<campaignId>/collaboration/<collaborationId>/deletion-request/<deletionRequestId>',
    },
}

export default apiConfig